export default {
    'future':'Talent training program',

    'Free':'Free Trial Lesson',
    'name':'Parent Full Name',
    'phone':'Phone Number',
    'email':'Email Address',
    'wechat':'WeChat ID(optional)',
    'nowechat':'Non-WeChat name',
    'submit':'Submit',

    'hotjoin':'Hot Registration',
    
    'age':'Student Age',
    'time':'Schedule',
    'day': '10 days/40 sessions',
    'type':'Format',
    'online':'Online interactive for students',
    'live':'Live streaming',
    'small': ' and small group classes',

    'freetrial': 'Free Trial',

    'math':'Math',
    'Drawing':'Drawing',
    'Coding':'Coding',
    'Literature':'English Literature Reading',

    'SUMMER CAMP':'SUMMER CAMP',

    'children':'What children get',

    'thinking':'Logical thinking ability',
    'empathy':'Understand empathy',
    'Imagination':'Imagination',
    'Creativity':'Creativity',
    'Social':'Social skills',

    'enrichment':'Online enrichment classes platform for students',
    'certification':'Top 5% USA teachers with standard teaching certification',

    'summer':'Classover Summer Camp',
    'society':'Facing the society, cultivating talents in an all-round way',

    'title_1':'My daughter has attended classover…',
    'comment_1':'My daughter has attended classover class for more than one year. She likes it a lot...',
    'title_1':'Interesting classes',
    'comment_2':'My son is taking reading writing and math classes for more than 1 year. He really enjoys learning..',
    "ctitle_3":"I especially like classover's small…",
    "comment_3":"I especially like classover's small class system, so that every child can be asked questions many times...",
    "Country Code":"Country Code",
    "Please select your country code":"Please select your country code",
    "Please verify and enter the text in the picture":"Please verify and enter the text in the picture",
    "The Verification Code can not be empty":"The Verification Code can not be empty",
    "Please enter the contents":"Please enter the contents",
    "Success":"Success",
    "Click Refresh Verification Code":"Click Refresh Verification Code",
    "Congratulations!":"Congratulations!",
    "You have claimed a free trial lesson":"You have claimed a free trial lesson",
   "Our Course Adviser will contact you shortly":"Our Course Adviser will contact you shortly",

   
}



// WEBPACK FOOTER //
// ./src/locales/en.js